import { render, staticRenderFns } from "./batch-details-list.vue?vue&type=template&id=72bfeca6"
import script from "./batch-details-list.vue?vue&type=script&lang=js"
export * from "./batch-details-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports